import { Center, Spinner, Text } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import useQueryParam from 'hooks/shared/useQueryParam';
import OperationsTable from 'presentation/components/modules/operations/OperationsTable';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import PaginationContentWrap from 'presentation/components/shared/pagination/PaginationContentWrap';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchOperationsQuery } from 'rtkQuery/sharespro/queries/operations';

const OperationsTableContainer: FC = () => {
  const { t } = useTranslation();

  const [accountId] = useAccountIdQueryParam();
  const [page, setPage] = useQueryParam<number>('page', {
    ifAbsent: 1,
    provider: (val) => parseInt(val),
  });

  const { isFetching, data, error, refetch } = useFetchOperationsQuery({
    page,
    broker_account_id: accountId,
  });

  let wrapByCard = true;
  let content;
  if (data) {
    if (data.items.length > 0) {
      content = (
        <PaginationContentWrap
          itemsCount={data.itemsCount}
          isFetching={isFetching}
          setPage={setPage}
          currentPage={data.currentPage}
          pageCount={data.pageCount}
        >
          <AppCard p="20px" mb="20px">
            <OperationsTable items={data.items} />
          </AppCard>
        </PaginationContentWrap>
      );
      wrapByCard = false;
    } else {
      content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <>
      <GridHeading>{t('operations')}</GridHeading>
      {content}
    </>
  );
};

export default OperationsTableContainer;
